import React from "react";

const getBadgeImage = (badgeString: string, size: number = 24): React.ReactNode => {
  return (
    <img
      alt=""
      height={size}
      src={`data:image/svg+xml;utf8,${encodeURIComponent(
        `
         <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            ${badgeString}
          </svg>
        `
      )}`}
      width={size}
    />
  );
};

export default getBadgeImage;
